import { getDatabase, set, ref, remove, onValue, off } from "firebase/database";
import firebaseApp from "./firebaseConfig";

class Database {
  constructor() {
    this.database = getDatabase(firebaseApp);
  }
  loadData(userId, onUpdate) {
    const query = ref(this.database, `${userId}/cards`);
    onValue(query, (snapshot) => {
      const data = snapshot.val();
      data && onUpdate(data);
    });
    return () => off(query);
  }
  updateData(userId, data) {
    set(ref(this.database, `${userId}/cards/${data.id}`), data);
  }
  deleteData(userId, data) {
    remove(ref(this.database, `${userId}/cards/${data.id}`));
  }
}

export default Database;
